<h1 mat-dialog-title id="signature-title">
    {{ title }}
    <mat-icon class="close-icon condenced" alt="Close dialog" (click)="closeModal(false)"> close </mat-icon>
</h1>
<div mat-dialog-content>
    <app-vehicle-edit [vehicle]="vehicleInfo" [deal]="dealInfo" [search]="search" [type]="type" [vehicleType]="vehicleType" (outEvent)="closeModal($event)">
    </app-vehicle-edit>
</div>
